export default __webpack_public_path__ + "static/media/media5.19c2e248.jpeg";